<template>
    <div>
        <vrm-header header-class="vrm-header__fluid">
            <template v-slot:header-controls>
                <div class="vrm-tasks">
                    <div class="vrm-tasks__task">
                        <vrm-toggle-button
                            v-model="search.active"
                            label-class="gtag-top-menu-item gtag-top-menu-item--search-groups"
                            icon-class="sg-vrm-icon_040_search-16px"
                        />
                    </div>
                </div>
            </template>
        </vrm-header>
        <vrm-title header-class="vrm-header__fluid">
            <template v-slot:page-title>
                <h1 class="vrm-page-title">
                    <span>{{ $t('attributes.groups', { i18nFallback: 'Data attributes' }) }}</span>
                </h1>
            </template>

            <template v-slot:header-panels>
                <vrm-header-search-panel
                    key="search"
                    v-model="search.query"
                    :open="search.active"
                />
            </template>

            <template v-slot:header-controls>
                <div class="vrm-tasks">
                    <div class="vrm-tasks__task">
                        <vrm-toggle-button
                            v-model="search.active"
                            label-class="gtag-top-menu-item gtag-top-menu-item--search-groups"
                            icon-class="sg-vrm-icon_040_search-16px"
                        />
                    </div>
                </div>
            </template>
        </vrm-title>
        <div class="container container__fluid">
            <p v-if="loading" class="sg-color-blue">
                {{ $t('core.loading', { i18nFallback: 'Loading...' }) }}
            </p>

            <p v-else-if="!items.length" class="sg-color-blue">
                {{
                    $t('attributes.no_attributes', {
                        i18nFallback: 'There are no data attributes matching your search.',
                    })
                }}
            </p>

            <vrm-scroll-fade class="vrm-scroll-fade--scroll-y-max">
                <table class="vrm-table vrm-table--compact vrm-table--sticky-header">
                    <thead>
                        <tr>
                            <th v-for="column in columns" :key="column">
                                {{ column }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in items" :key="i" @click="toggleRowExpansion(item)">
                            <td v-for="(ite, j) in item" :key="j">
                                {{ ite }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </vrm-scroll-fade>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmHeader from '@/vue/components/layout/VrmHeader.vue';
import VrmTitle from '@/vue/components/layout/VrmTitle.vue';
import VrmHeaderSearchPanel from '@/vue/components/molecules/VrmHeaderSearchPanel.vue';
import VrmToggleButton from '@/vue/components/shared/toggles/VrmToggleButton.vue';
import VrmScrollFade from '../../../shared/VrmScrollFade.vue';

@Component({
    components: { VrmToggleButton, VrmHeaderSearchPanel, VrmHeader, VrmScrollFade, VrmTitle },
})
@AngularRoute('base.admin-attributes', '/admin/attributes', { slot: 'main' })
@AngularLocaleBundle('core')
export default class Attributes extends Vue {
    /** @type AttributesService */
    @ngInject()
    AttributesService;
    loading = false;
    search = { active: true, query: '' };

    get items() {
        return this.$store.state.AttributesService.items;
    }

    get columns() {
        return this.$store.state.AttributesService.columns;
    }

    @Watch('search.query')
    async onSearchQueryChanged(newValue) {
        return this.AttributesService.filter(newValue);
    }

    async created() {
        return this.AttributesService.loadDataAttributes();
    }
}
</script>
